module.exports = __webpack_public_path__ + "img/1-2.0245e523.png";